/* Affiliate application (sections/vitto-affiliate.liquid): nothing is sent yet. A valid email opens the thank-you
 * popup and clears the field. Listeners sit on the document so they survive the theme editor reloading the section. */
(function () {
  function openDialog(dialog) {
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-vt-affiliate-form]');
    if (!form) return;
    event.preventDefault();

    var root = form.closest('[data-vt-affiliate]');
    var dialog = root && root.querySelector('[data-vt-affiliate-dialog]');
    if (!dialog) return;

    form.reset();
    openDialog(dialog);
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-vt-affiliate-close]')) {
      closeDialog(event.target.closest('[data-vt-affiliate-dialog]'));
      return;
    }
    // A click on the backdrop lands on the dialog element itself.
    if (event.target.matches && event.target.matches('[data-vt-affiliate-dialog]')) closeDialog(event.target);
  });
})();
